package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class DeleteVizioAccountResponse(
    val status: String? = null,
    val description: String? = null
)